﻿import { SSOOption, SSOInfo, SSOResult, UserProfile } from "./sso-options.js";
import { JSEncrypt } from "jsencrypt";
import { b64tohex, hextob64, KEYUTIL, KJUR, RSAKey } from "jsrsasign";
import Modal from "./modal";
class SSO {
  constructor(option) {
    // 初始化SSO实例
    if (option) {
      // 使用传入的配置参数
      this.option = option;
    } else {
      // 使用默认配置
      let PUBLIC_KEY = "";
      let PRIVATE_KEY = "";
      let SSOHost = "https://sso.geoppt.com";
      let AppKey = "";
      let PublishKey = `-----BEGIN PUBLIC KEY-----\n${PUBLIC_KEY}\n-----END PUBLIC KEY-----`;
      let PrivateKey = `-----BEGIN PRIVATE KEY-----\n${PRIVATE_KEY}\n-----END PRIVATE KEY-----`;
      this.option = new SSOOption(SSOHost, AppKey, PublishKey, PrivateKey);
    }
    this._frame = null;
  }
  //开始授权
  auth() {
    // 开始SSO授权流程
    //this.intervalID=setInterval(this.checkUserStatus.bind(this), this._interval);
    //初始化iframe并加载sso
    var _this = this;
    if (!this._frame) {
      // 创建隐藏iframe
      var iframe = document.createElement("iframe");
      iframe.style.display = "none";
      document.body.appendChild(iframe);
      iframe.src = this.option.host + "/v/auth/status";
      // 监听父页面的消息
      window.addEventListener(
        "message",
        function (event) {
          if (event.origin == _this.option.host) {
            if (event.data.type == "ssoauth") {
              _this["onauth"] && _this["onauth"](event.data.message);
            }
            if (event.data.type == "encrypted_auth") {
              _this["on_encrypted_auth"] &&
                _this["on_encrypted_auth"](event.data.message);
              _this["onencrypted_auth"] &&
                _this["onencrypted_auth"](event.data.message);
            } else if (event.data.type == "login") {
              _this["onlogin"] && _this["onlogin"](event.data.message);
            } else if (event.data.type == "logout") {
              _this["onlogout"] && _this["onlogout"](event.data.message);
            }
          }
        },
        false
      );
      this._frame = iframe;
      //发送消息给sso开始校验ssoStatus

      // IFRAME加载完成处理
      this._frame.onload = function () {
        console.log("frame load complete");
        iframe.contentWindow.postMessage(
          JSON.stringify({ cmd: "checkSSOStatus", target: window.origin }),
          "*"
        );
        iframe.contentWindow.postMessage(
          JSON.stringify({
            cmd: "checkSSOStatusEncrypted",
            target: window.origin,
            appKey: _this.option.appKey,
          }),
          "*"
        );
      };
      this._frame.contentWindow.onerror = function () {
        console.log("frame load error");
        this["onerror"] && this["onerror"]("sso初始化失败");
      };
    }
    this._frame.contentWindow.postMessage(
      JSON.stringify({ cmd: "checkSSOStatus", target: window.origin }),
      "*"
    );
    this._frame.contentWindow.postMessage(
      JSON.stringify({
        cmd: "checkSSOStatusEncrypted",
        target: window.origin,
        appKey: _this.option.appKey,
      }),
      "*"
    );
  }

  //事件监听
  on(eventName, eventHandler) {
    this["on" + eventName] = eventHandler;
  }
  //事件移除监听
  off(eventName) {
    this["on" + eventName] = null;
  }
  //登录
  login(token) {
    this._frame.contentWindow.postMessage(
      JSON.stringify({ cmd: "login", extra: token, target: window.origin }),
      "*"
    );
    this["onlogin"] && this["onlogin"]();
  }
  //登出
  logout() {
    this._frame.contentWindow.postMessage(
      JSON.stringify({ cmd: "logout", target: window.origin }),
      "*"
    );
    this["onlogout"] && this["onlogout"]();
  }

  /**
   * 使用弹窗登录操作
   * @param {Object} options - 配置选项
   * @param {Function} options.onSuccess - 登录成功时的回调函数
   * @param {Function} options.onFail - 登录失败时的回调函数
   *  @param {Function} options.onClose - 弹窗关闭时的回调函数
   */
  loginWithDialog({ onSuccess, onFail, onClose }) {
    const modal = Modal.createModal();
    document.body.appendChild(modal);
    modal.addEventListener("modal-message", (event) => {
      // if (event.origin !== this.option.host) return;
      const { action, data } = event.detail;
      if (action === "login-success") {
        if (typeof onSuccess === "function") {
          onSuccess(data);
        }
        modal.close();
      } else if (action === "login-fail") {
        if (typeof onFail === "function") {
          onFail(data);
        }
      }
    });

    modal.addEventListener("close", () => {
      if (modal.parentElement) {
        document.body.removeChild(modal);
      }
      // 触发 onClose 回调
      if (typeof onClose === "function") {
        onClose("close");
      }
    });
    const encodedRedirectUrl = encodeURIComponent(window.location.href);
    modal.open(
      `${this.option.host}/v/auth/dialog?appKey=${this.option.appKey}&redirect=${encodedRedirectUrl}`
    );
  }

  /**
   * 使用页面方式登录，支持配置是否在新标签页中打开
   * @param {Object} params - 参数对象
   * @param {string} params.redirectUrl - 登录成功后重定向的URL
   * @param {boolean} [params.openInNewTab=false] - 是否在新标签页中打开登录页面
   */
  loginWithRedirect({ redirectUrl, openInNewTab = false }) {
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    const loginUrl = `${this.option.host}/v/auth/login?redirect=${encodedRedirectUrl}&appKey=${this.option.appKey}`;
    if (openInNewTab) {
      // 在新标签页中打开
      window.open(loginUrl, "_blank");
    } else {
      // 在当前页面中打开
      window.location.href = loginUrl;
    }
  }

  guid() {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (
      S4() +
      S4() +
      "-" +
      S4() +
      "-" +
      S4() +
      "-" +
      S4() +
      "-" +
      S4() +
      S4() +
      S4()
    );
  }
  toAuthenticationUrl() {
    debugger;
    //先签名再加密(不加密签名信息)
    let timestamp = new Date().valueOf();
    let clientID = this.guid();
    let url = "";
    //公钥加密数据
    let anthParamter = `timestamp=${timestamp}&clientID=${clientID}`;
    let authInfoEncrypted = this.rsaEncrypt(anthParamter);
    let query = `?appkey=${this.option.appKey}&auth=${authInfoEncrypted}`;
    let sign = this.signature(query);
    url = `${this.option.host}/auth/login?appkey=${
      this.option.appKey
    }&auth=${encodeURIComponent(
      authInfoEncrypted
    )}&signtext=${encodeURIComponent(sign)}`;
    return url;
  }
  toLogoutUrl() {}
  decrypt(url, auth, signtext) {
    let decryptResult = new SSOResult();
    if (!url) {
      decryptResult.Success = false;
      decryptResult.Message = "url is empty";
      return decryptResult;
    }
    if (!auth) {
      decryptResult.Success = false;
      decryptResult.Message = "auth is empty";
      return decryptResult;
    }
    if (!signtext) {
      decryptResult.Success = false;
      decryptResult.Message = "signtext is empty";
      return decryptResult;
    }
    //签名验证
    try {
      url = decodeURIComponent(url);
      auth = decodeURIComponent(auth);
      let urlSelf = url.replace("&signtext=.*$", "");
      // Uri uri = new Uri(urlSelf);
      var _query = url.substring(url.indexOf("?"), url.indexOf("&"));
      // let signHashData =MD5(_query).toString();//Crypto.Hash(uri.Query);
      // var wordArray = enc.Hex.parse(signHashData);
      // var signHashBase64Data = enc.Base64.stringify(wordArray);
      //签名
      //var sign=this.signature(signHashBase64Data);
      // 验签
      var verifyResult = this.verify(signtext, _query);
      if (!verifyResult) {
        decryptResult.Success = false;
        decryptResult.Message = "签名无效";
        return decryptResult;
      }
      //解密:
      var decryptData = this.rsaDecrypt(auth);
      if (decryptData) {
        var params = {};
        var _querys = decryptData.split("&");
        var getParamVal = function (propName) {
          for (var i = 0; i < _querys.length; i++) {
            var paramArray = _querys[i].split("=");
            if (paramArray.length == 2) {
              if (paramArray[0] == propName) {
                return paramArray[1];
              }
            }
          }
          return "";
        };
        decryptResult.Success = true;
        decryptResult.Data = new SSOInfo();
        decryptResult.Data.SessionID = getParamVal("session");
        decryptResult.Data.UserID = getParamVal("id"); //authParameters.Get("EMail");
        return decryptResult;
      }
    } catch (e) {
      console.log(e);
      decryptResult.Success = false;
      decryptResult.Message = "登录请求数据被非法篡改";
      return decryptResult;
    }
    //获取参数
    // var authParameters = Crypto.RSADecrypt(PrivateKey, auth)
    //     .Split('\n')
    //     .Select(p => p.Split(new[] { '=' }, 2, StringSplitOptions.RemoveEmptyEntries))
    //     .Where(p => p.Length == 2)
    //     .ToDictionary(p => p[0], p => p[1], StringComparer.OrdinalIgnoreCase);
    // if (authParameters.Count == 0)
    // {
    //     throw new Exception("认证参数无效");
    // }
    // //校验时间戳
    // string timestamp = authParameters["timestamp"];
    // if (Math.Abs((DateTime.Now - new DateTime(Convert.ToInt64(timestamp))).TotalSeconds) >= 5 * 60)
    // {
    //     throw new Exception("授权请求已过期!");
    // }
    return decryptResult;
  }
  async sessionToToken(sessionID) {
    let url = `${this.option.host}/auth/sessionToToken?sessionID=${sessionID}`;
    let tokenResult = new SSOResult();
    await fetch(url)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.Success) {
          tokenResult.Success = true;
          tokenResult.Data = data.Data;
        } else {
          tokenResult.Success = false;
          tokenResult.Message = data.Message;
        }
      })
      .catch(function (e) {
        tokenResult.Success = false;
        tokenResult.Message = JSON.stringify(e);
      });
    return tokenResult;
  }
  async userProfile(token) {
    let userProfileResult = new SSOResult();
    let url = `${this.option.host}/user/profile?token=${token}`;
    await fetch(url)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        userProfileResult = data;
        userProfileResult.Data = data.Data;
      })
      .catch(function (e) {
        userProfileResult.Success = false;
        userProfileResult.Message = JSON.stringify(e);
      });
    return userProfileResult;
  }
  signature(data) {
    var key = KEYUTIL.getKey(this.option.privateKey);
    console.log(key);
    // 创建 Signature 对象
    let signature = new KJUR.crypto.Signature({ alg: "MD5withRSA" });
    // 传入key实例, 初始化signature实例
    // signature.init(key);
    signature.init(this.option.privateKey);
    // 传入待签明文
    let a = signature.signString(data);
    // 签名, 得到16进制字符结果
    // let a = signature.sign();
    let sign = hextob64(a);
    console.log(sign);
    return sign;
  }
  verify(sign, data) {
    try {
      let signatureVf = new KJUR.crypto.Signature({ alg: "MD5withRSA" });
      var pkey = KEYUTIL.getKey(this.option.publicKey);
      console.log(pkey);
      signatureVf.init(this.option.publicKey);
      signatureVf.updateString(data);
      // !接受的参数是16进制字符串!
      let b = signatureVf.verify(b64tohex(sign));
      console.log("jsrsasign verify: " + b);
      return b;
    } catch (e) {
      console.error(e);
      return false;
    }
  }
  rsaEncrypt(data) {
    let jse = new JSEncrypt({ default_key_size: "1024" });
    jse.setPublicKey(this.option.publicKey);
    let encrypt = jse.encrypt(data);
    return encrypt;
  }
  rsaDecrypt(data) {
    var encrypt = new JSEncrypt({ default_key_size: "2048" });
    encrypt.setPrivateKey(this.option.privateKey);
    let decrypted = encrypt.decrypt(data); // 对密码进行加密
    return decrypted;
  }
}
export default SSO;
